import { useSynapse } from 'app/lib/synaptik';
import React, { useState, useCallback } from 'react';
import { OnboardingProvider } from '../Onboarding';
import { useOnboardingContext } from '../Onboarding/hooks';
import { SignUpWithEligibility } from '../SignUp';
import { SignUpPageWithRouter } from '../SignUp/SignUpPageWithRouter';
import { EcommTestEligibility } from './EcommTestEligibility';

export const Registration: React.FunctionComponent = () => {
  const [isEligibilityConfirmed, setIsEligibilityConfirmed] = useState(false);
  const handleEligibilityContinue = () => {
    setIsEligibilityConfirmed(true);
  };

  const [service, serviceSlug, registerEcommUser, requestedDrug] = useSynapse(({ services, user }) => [
    services.getIntendedService(),
    services.getIntendedServiceSlug(),
    user.registerEcommUser,
    services.getRequestedDrug(),
  ]);

  const { profile } = useOnboardingContext();

  const signUp = useCallback(
    (registrationParams: { email: string; password: string; consentedToHma: boolean }) => {
      registerEcommUser({
        ...registrationParams,
        ...profile,
        serviceSlug,
        requestedDrug,
      });
    },
    [registerEcommUser, profile, serviceSlug, requestedDrug]
  );

  return service ? (
    isEligibilityConfirmed ? (
      <SignUpPageWithRouter signUp={signUp} />
    ) : (
      <EcommTestEligibility onContinue={handleEligibilityContinue} service={service} />
    )
  ) : (
    <SignUpWithEligibility />
  );
};

export const EcommTestRegistration = (props: Record<string, unknown>) => {
  return (
    <OnboardingProvider>
      <Registration {...props} />
    </OnboardingProvider>
  );
};
